export default __webpack_public_path__ + "static/algorithm-and-data-structure-ed2f3306c39074e55a653b0a1d4efb3e.webp";